import { GUEST_BULK_PICKUP_PRICING_RESET } from "constants-lib/actionTypes"

export const resetGuestBulkPickupPricing = () => ({
  type: GUEST_BULK_PICKUP_PRICING_RESET,
})
